import ModelEntity from "../model-entity"
import ModelProxy from "../model-proxy"
import {EntityType} from "../../gd/const/item"
import DatetimeUtils from "../../gd/utils/datetime-utils"
import isSameValue from "../../gd/utils/misc/is-same-value"
import AttachmentsCollection from "../attachment/attachments"

const debug = false
// const debug = "Message"

export default class Message extends ModelEntity {

    fromUserId?             : ID
    editByUserId?           : ID

    momentCreated           : Moment | null
    editDate                : Moment | null

    attachments             : AttachmentsCollection
    contentText             : string | null
    contentRTF              : any

    isDeleted               : boolean

    render                  : {
        isUserChanged   : boolean
        isFirst         : boolean
        isLast          : boolean
    }

    constructor(data: any, useProxy = true) {
        super(data.id, EntityType.COMMENT)

        // data structure
        /* {
            "momentCreated": "2024-04-08T11:24:50.744966",
            "attachments": null,
            "companyId": "PGUOPE",
            "parentEntityId": 164,
            "userId": null,
            "messageTxt": "comment 1",
            "messageRtf": null,
            "parentEntityType": 28,
            "params": null,
            "type": null,
            "id": "xcCyuq",
            "isDeleted": false
        }*/

        this.fromUserId     = _.get(data, "userId", undefined) || _.get(data, "fromUserId", undefined)
        this.editByUserId   = _.get(data, "editByUserId", undefined)

        this.momentCreated  = DatetimeUtils.datetimeToMoment(data.momentCreated)
        this.editDate       = DatetimeUtils.datetimeToMoment(data.editDate)

        this.attachments    = new AttachmentsCollection(_.get(data, "attachments", []))
        this.contentText    = _.get(data, "messageTxt", null) || _.get(data, "contentText", null)
        this.contentRTF     = _.get(data, "messageRtf", null) || _.get(data, "contentRTF", null)

        this.attachments.applyMessageRTF(this.contentRTF)

        this.isDeleted      = _.get(data, "isDeleted", false)

        this.render         = {
            isUserChanged   : true,
            isFirst         : false,
            isLast          : false,
        }

        return useProxy ? new Proxy(this, ModelProxy) : this
    }

    applyDelta(data:any) {
        let isChanged = false

        _.mapKeys(data, (value ,key)=>{
            if (key === 'id') return

            switch (key) {
                case 'editDate':
                    if (!isSameValue(this, key, value)) {
                        this.editDate = DatetimeUtils.datetimeToMoment(value)
                        isChanged = true
                    }
                    break

                case 'messageTxt':
                    if (!isSameValue(this, 'contentText', value)) {
                        this.contentText = value
                        isChanged = true
                    }
                    break

                case 'messageRtf':
                    if (!isSameValue(this, 'contentRTF', value)) {
                        this.contentRTF = value
                        isChanged = true
                    }
                    break

                case 'attachments':
                    if (!isSameValue(this, 'attachments', value)) {
                        this.attachments = new AttachmentsCollection(_.get(data, "attachments", []))
                        isChanged = true
                    }
                    break

                default:
                    if (!isSameValue(this, key, value)) {
                        // @ts-ignore
                        this[key] = value
                        isChanged = true
                    }
            }

            debug && console.log(debug, "applyDelta", key, value, isChanged)
        })

        this.attachments.applyMessageRTF(this.contentRTF)

        return isChanged
    }

    get lastUpdatedTime(): Moment {
        return this.editDate || this.momentCreated || moment()
    }

    isEditAllowed() {
        return true
    }

    toJSON() {
        return {
            id              : this.id,

            fromUserId      : this.fromUserId,
            editByUserId    : this.editByUserId,

            momentCreated   : DatetimeUtils.momentToUTCISODatetime(this.momentCreated),
            editDate        : this.editDate ? DatetimeUtils.momentToUTCISODatetime(this.editDate) : undefined,

            attachments     : this.attachments.toJSON(),

            contentText     : this.contentText,
            contentRTF      : this.contentRTF,
        }
    }
}
